import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography"; // Limitless Imports

import CustomerDialogue from "../dialogues/customer-dialogue/CustomerDialogue";
import ExpertDialogue from "../dialogues/expert-dialogue/ExpertDialogue";
import SystemExpiryDialogue from "../dialogues/system-expiry-dialogue/SystemExpiryDialogue";
import SystemInfoDialogue from "../dialogues/system-info-dialogue/SystemInfoDialogue";
import TypingIndicator from "../dialogues/typing-indicator/TypingIndicator";
import SuggestedAnswerDialogueCarousel from "../dialogues/suggested-answer-dialogue-carousel/SuggestedAnswerDialogueCarousel";
import { withi18n } from "../hocs/i18n";
import CustomerAttachmentDialogue from "../dialogues/customer-dialogue/CustomerAttachmentDialogue";
import ExpertAttachmentDialogue from "../dialogues/expert-dialogue/ExpertAttachmentDialogue";

var Conversation = /*#__PURE__*/function (_Component) {
  _inherits(Conversation, _Component);

  var _super = _createSuper(Conversation);

  function Conversation() {
    var _this;

    _classCallCheck(this, Conversation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      preventScrolling: _this.props.dialoguesVisible,
      firstLoad: true
    };

    _this.scrollToBottom = function () {
      // "messagesAnchor" is an empty div at the end of the message list
      _this.messagesAnchor.scrollIntoView({
        block: "end",
        behavior: "smooth"
      });
    };

    _this.handleSAFullScreen = function (isFullScreen) {
      _this.props.dialoguesVisible(isFullScreen);

      if (isFullScreen === true) {
        setTimeout(function () {
          return _this.messagesAnchor.scrollIntoView({
            block: "end",
            behavior: "instant"
          });
        }, 10);
      }
    };

    _this.updateDateHeader = function (dialogue, index) {
      var classes = _this.props.classes;

      if (dialogue.dateCaption) {
        return /*#__PURE__*/React.createElement("div", {
          key: dialogue.dialogueId,
          className: classes.messageContainer
        }, /*#__PURE__*/React.createElement(Typography, {
          className: classes.dayText,
          component: "div"
        }, _this.props.t(dialogue.dateCaption)), _this.renderDialogue(dialogue, index));
      } else {
        return _this.renderDialogue(dialogue, index);
      }
    };

    _this.renderDialogue = function (dialogue, index) {
      var _this$props = _this.props,
          clearSuggestedAnswers = _this$props.clearSuggestedAnswers,
          dialoguesVisibility = _this$props.dialoguesVisibility,
          logger = _this$props.logger,
          isHistoryMessage = _this$props.isHistoryMessage,
          isReported = _this$props.isReported,
          message = _this$props.message;
      var firstLoad = _this.state.firstLoad;
      var shouldAnimate = !firstLoad; //is this the last Dialogue?

      var lastDialogue = index === _this.props.dialogues.length - 1 ? true : false; //if we're a history message and the last dialogue, don't animate

      shouldAnimate = lastDialogue && isHistoryMessage && firstLoad ? false : shouldAnimate; //is this the first Dialogue?

      var firstDialogue = index === 0 ? true : false;
      logger.debug("".concat(index, ", ").concat(_this.props.dialogues.length - 1, " last: ").concat(lastDialogue, ", first: ").concat(firstDialogue, "  history message? ").concat(isHistoryMessage, ", shouldAnimate: ").concat(shouldAnimate, ", firstLoad: ").concat(firstLoad));

      if (dialogue.origin === "customer") {
        if (dialoguesVisibility) {
          if (dialogue.type === "attachment") {
            return /*#__PURE__*/React.createElement(CustomerAttachmentDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: !firstDialogue && lastDialogue && shouldAnimate
            });
          } else {
            return /*#__PURE__*/React.createElement(CustomerDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: !firstDialogue && lastDialogue && shouldAnimate
            });
          }
        }
      } else if (dialogue.origin === "system" && dialogue.type === "information") {
        return dialoguesVisibility && /*#__PURE__*/React.createElement(SystemInfoDialogue, {
          dialogue: dialogue,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate
        });
      } else if (dialogue.origin === "system" && dialogue.type === "expiry") {
        return dialoguesVisibility && /*#__PURE__*/React.createElement(SystemExpiryDialogue, {
          dialogue: dialogue,
          key: dialogue.dialogueId,
          shouldAnimate: lastDialogue && shouldAnimate
        });
      } else if (dialogue.origin === "expert" && dialogue.type === "suggestedAnswer") {
        //only show suggested answers if they're the last dialogue
        if (!lastDialogue) {
          return /*#__PURE__*/React.createElement("div", {
            key: 1
          });
        }

        return /*#__PURE__*/React.createElement(SuggestedAnswerDialogueCarousel, {
          key: dialogue.created,
          dialogue: dialogue,
          handleSuggestedAnswerSelection: _this.props.handleSuggestedAnswerSelection,
          handleFullScreen: _this.handleSAFullScreen,
          unmount: clearSuggestedAnswers,
          message: message
        });
      } else if (dialogue.origin === "expert" && dialogue.type === "suggestedEscalation") {
        //no suggested escalation
        return /*#__PURE__*/React.createElement("div", {
          key: 2
        });
      } else {
        if (dialoguesVisibility) {
          if (dialogue.type === "attachment") {
            return /*#__PURE__*/React.createElement(ExpertAttachmentDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: lastDialogue && shouldAnimate,
              isReported: isReported,
              message: message
            });
          } else {
            return /*#__PURE__*/React.createElement(ExpertDialogue, {
              dialogue: dialogue,
              key: dialogue.dialogueId,
              shouldAnimate: lastDialogue && shouldAnimate,
              isReported: isReported,
              message: message
            });
          }
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        key: 3
      });
    };

    return _this;
  }

  _createClass(Conversation, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var newState = {};

      if (nextProps.dialoguesVisible !== this.props.dialoguesVisible) {
        newState.preventScrolling = nextProps.dialoguesVisible;
      }

      if (this.props.dialogues.length > 0 && this.state.firstLoad) {
        newState.firstLoad = false;
      }

      if (newState) {
        this.setState(newState);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      //when the component receives new messages, scroll to the bottom
      if (this.props.scrollOnLoad) {
        this.scrollToBottom();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          dialogues = _this$props2.dialogues,
          typing = _this$props2.typing,
          claimer = _this$props2.claimer,
          classes = _this$props2.classes,
          t = _this$props2.t,
          poweredByEnabled = _this$props2.poweredByEnabled,
          message = _this$props2.message;
      var preventScrolling = this.state.preventScrolling;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(classes.conversationContainer, " ").concat(preventScrolling && classes.preventScrolling),
        id: "limitless-allow-scroll"
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.messageList
      }, dialogues.map(function (dialogue, index) {
        return _this2.updateDateHeader(dialogue, index);
      })), typing && /*#__PURE__*/React.createElement(TypingIndicator, {
        claimer: claimer,
        message: message
      }), poweredByEnabled && /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        align: "center",
        className: classes.poweredBy,
        component: "div"
      }, t("Powered by Limitless")), /*#__PURE__*/React.createElement("div", {
        style: {
          float: "left",
          clear: "both"
        },
        ref: function ref(el) {
          _this2.messagesAnchor = el;
        }
      }));
    }
  }]);

  return Conversation;
}(Component);

var styles = function styles(theme) {
  return {
    conversationContainer: {
      height: "100%",
      position: "relative",
      overflow: "auto",
      backgroundImage: "url(".concat(theme.background.image, ")"),
      backgroundSize: "100% 100%",
      backgroundRepeat: "no-repeat"
    },
    preventScrolling: {
      overflowY: "none"
    },
    messageList: {
      boxSizing: "border-box",
      margin: "auto 0 0",
      padding: "0",
      width: "100%"
    },
    messageListProgress: {
      alignItems: "center",
      background: "#fff",
      borderRadius: "14px",
      fontSize: "13px",
      lineHeight: "1.333",
      marginBottom: "10px",
      padding: "11px 10px",
      marginRight: "33%",
      color: "white",
      textAlign: "center"
    },
    messageContainer: {
      width: "100%",
      paddingTop: "10px"
    },
    hrstyle: {
      position: "relative",
      width: "100%",
      marginTop: "10px",
      paddingTop: "0px",
      borderTopColor: "black",
      borderTopStyle: "hidden",
      borderTopWidth: "1px"
    },
    dayText: {
      position: "relative",
      margin: "0px auto",
      textAlign: "center",
      color: theme.palette.contrast.text
    },
    poweredBy: {
      color: theme.palette.contrast.text,
      paddingBottom: 10
    }
  };
};

export default withStyles(styles)(withi18n(Conversation, "Conversation"));
Conversation.defaultProps = {
  scrollOnLoad: true,
  poweredByEnabled: false,
  isReported: false
};